import React, { useState } from 'react';
import { DropZone } from '../../../components/alta-comercios/dropzone';
import { Box } from '@mui/material';
import ButtonGradient from '../../../components/utils/button/ButtonGradient';
import { useRecoilState, useRecoilValue } from 'recoil';
import { afipData, userCredentials } from '../../../recoilState/GlobalState';
import { UrlDocumentosGet } from '../../../services/hooli-services/Documentos/UrlDocumentosGet';
import { DocumentosPut } from '../../../services/hooli-services/Documentos/DocumentosPut';

export function ContainerConstanciaIngresosBrutos({nextStep, setStepDocumentos}) {
    const [file,setFile] = useState(null);
    const [credentials, setCredentials] = useRecoilState(userCredentials);
    const recoilAfipData = useRecoilValue(afipData);
    const urlDoc = async() => {
      const url = await UrlDocumentosGet(credentials, `${recoilAfipData.cuit.replaceAll('-', '')}_IIBB`);
      await sendFile(url.result[0].url)
    }
    
    const sendFile = async (url) => {
      await DocumentosPut(url, file[0])
    }

    const handleSubmit = ()=> {
      urlDoc();
      if(recoilAfipData.personaFJ === "J"){ 
        setStepDocumentos({
          step:3,
          title: "Contrato Social",
          subtitle:"Subí tu contrato social."
        })
      } else {
        nextStep(4)
      }
    }
  return (
   <> 
    <DropZone file={file} setFile={setFile}/>
    <Box> 
            <ButtonGradient size={"medium"} text={"Continuar"} action={handleSubmit} disabled={!file}/>
          </Box>
          <Box marginTop={"15px"} marginBottom={"15px"}> 
          <ButtonGradient size={"medium"} text={"Volver"} color="transparent" action={()=>setStepDocumentos({
           step: 1, 
           title: "Constancia de Inscripción de AFIP",
           subtitle: "Podés descargar tu constancia de inscripcion desde el sitio web de la AFIP"
        })}/>
        </Box>
   </>
        
    
  )
}

 
